import React, {PureComponent, Fragment} from "react"
import {Route, match as Match} from "react-router"

import {NestedRoute, IndexRedirect} from "@irati/utils/history/routing"
import authentication from "@irati/auth"

import Overall from "../containers/Reporting/Overall"
import Celebrations from "../containers/Reporting/Celebrations"
import Perks from "../containers/Reporting/Perks"

interface Props {
  match: Match,
  apps: {}
}

class Reporting extends PureComponent<Props> {
  render() {
    const {match} = this.props

    const isPerksEnabled = authentication.apps("perks")
    const isRewardAndRecognitionEnabled =
      authentication.apps("recognition") && !authentication.apps("recognition.recognition.rewardDisabled")

    return (
      <Route
        path={match.url}
        render={() => (
          <Fragment>
            <NestedRoute match={match.url} path="/overall" component={Overall} />
            {isRewardAndRecognitionEnabled &&
              <NestedRoute match={match.url} path="/celebrations" component={Celebrations} />
            }
            {isPerksEnabled &&
              <>
                <NestedRoute match={match.url} path="/perks" component={Perks} />
              </>
            }
            <IndexRedirect match={match.url} to="/overall" title="Admin Analytics Overall" />
          </Fragment>
        )} />
    )
  }
}

export default Reporting
